import styled from "styled-components";
import { Colors } from "../../../styles/colors";

export const Container = styled.div`
	background-color: #ffffff;
	height: 539px;
	width: 722px;
	border-radius: 30px;
	place-content: center;
	color: black;
	display: flex;
	flex-direction: column;
	align-items: center;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
	position: relative;

	.close {
		width: 1.738rem;

		position: absolute;
		right: 2rem;
		top: 2rem;

		cursor: pointer;
	}

	.alert {
		margin-bottom: 3rem;
		width: 12%;
	}

	.divText {
		width: 90%;
		margin-top: 30px;
		height: 65%;
		flex-direction: column;
		align-items: center;
		display: flex;
	}

	.title {
		color: #5c5b5b;
	}

	.text {
		color: #b3b3b3;
		font-weight: 400;
		font-family: Roboto;
		font-size: 1.625rem;
		line-height: 30.47px;
		text-align: center;
		margin-top: 2rem;
		margin-bottom: 2rem;

		b {
			color: #5c5b5b;
			font-weight: 500;
		}
	}

	.numeroPacientes {
		color: ${Colors.tertirary_red_1_dark};
	}

	.button {
		font-family: Roboto;
		font-size: 1.3rem;
		font-weight: 600;
		line-height: 1.758rem;
		color: #ffffff;
		width: 18rem;
		height: 3.3rem;
		border: 0;
		border-radius: 0.5rem;
		margin-top: 3rem;
		box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
	}

	.upgrade {
		background: ${Colors.primary_blue_k_main};;
		transition: all 0.3s ease;
		color: #ffffff;
	}
`;
